import AppError from "@/pages/app-error";
import { Navigate, isRouteErrorResponse, useParams, useRouteError } from "react-router-dom";
import { WretchError } from "wretch/resolver";

export function InvoiceCorrectionError() {
    const params = useParams();
    const error = useRouteError();

    if (error instanceof WretchError || isRouteErrorResponse(error)) {
        if (error.status == 404) {
            return <Navigate to={`/outils/correction-facture?not_found=${params.invoice_number}`} />;
        }
    }

    return <AppError />;
}
